import React, { useState } from 'react';
import './BookingModal.css';

export interface BookingPrompt {
  classId: string;
  classDate: string;
  dayOfWeek: string;
  time: string;
  instructor: string;
  className: string;
  dfAvailable: number;
}

interface BookingModalProps {
  prompt: BookingPrompt;
  onBook: () => Promise<void>;
  onSkip: () => void;
  onDismiss: () => void;
}

export function BookingModal({ prompt, onBook, onSkip, onDismiss }: BookingModalProps) {
  const [isBooking, setIsBooking] = useState(false);
  const [error, setError] = useState('');

  const formatDate = (dateStr: string, dayOfWeek: string) => {
    const [, m, d] = dateStr.split('-');
    return `${dayOfWeek} ${+d}/${+m}`;
  };

  const handleBook = async () => {
    setIsBooking(true);
    setError('');
    try {
      await onBook();
    } catch (err: any) {
      setError(err.message || 'Booking failed');
      setIsBooking(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onDismiss}>
      <div className="booking-modal" onClick={(e) => e.stopPropagation()}>
        <div className="booking-modal__header">
          <h3 className="booking-modal__title">Book Class?</h3>
        </div>

        <div className="booking-modal__class">
          <div className="booking-modal__date">{formatDate(prompt.classDate, prompt.dayOfWeek)}</div>
          <div className="booking-modal__details">
            <span className="booking-modal__time">{prompt.time}</span>
            <span className="booking-modal__separator" />
            <span className="booking-modal__instructor">{prompt.instructor}</span>
          </div>
          <div className="booking-modal__meta">
            <span>{prompt.className}</span>
            <span className="booking-modal__spots">
              {prompt.dfAvailable} DF {prompt.dfAvailable === 1 ? 'spot' : 'spots'} available
            </span>
          </div>
        </div>

        {error && <div className="booking-modal__error">{error}</div>}

        <div className="booking-modal__actions">
          <button className="booking-modal__btn booking-modal__btn--book" onClick={handleBook} disabled={isBooking}>
            {isBooking ? 'Booking...' : 'Auto Book DF'}
          </button>
          <button className="booking-modal__btn booking-modal__btn--skip" onClick={onSkip} disabled={isBooking}>
            No (Don&apos;t Remind)
          </button>
          <button className="booking-modal__btn booking-modal__btn--later" onClick={onDismiss} disabled={isBooking}>
            Maybe Later
          </button>
        </div>
      </div>
    </div>
  );
}
